module.exports = __webpack_public_path__ + "img/logo.2d55e04f.svg";